<p-dataTable [value]="data" [paginator]="paginator" [rows]="rows"  [rowsPerPageOptions]="[5,10,20]" [totalRecords]="totalRecords" (onLazyLoad)="loadCarsLazy($event)">
  <p-column *ngFor="let col of cols" [field]="col.field" [header]="col.header"></p-column>
</p-dataTable>

<!-- [paginator]="true" [rows]="10" [rowsPerPageOptions]="[5,10,20]" [totalRecords]="totalRecords" (onLazyLoad)="loadCarsLazy($event)" -->